/// <amd-module name="Agile/Board/Badge/Models/BoardBadgeInfo" />
export interface IBoardBadgeInfo {
    badgeUrl: string;
    badgeMarkdown: string;
}
